"use client";

import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import { ReadMoreBlock } from "@/components/ReadMoreBlock";

const bodyClass =
  "max-w-[42rem] text-[var(--on-surface-variant)] leading-[1.65] text-[1.0625rem] sm:text-lg";
const rhythmClass =
  "mt-8 max-w-[42rem] text-[0.8125rem] sm:text-[var(--label-md)] uppercase tracking-[0.14em] text-[var(--on-surface-variant)]/65 font-medium leading-relaxed";

export function ServicesHeroExpandable() {
  const t = useTranslations("servicesHub");
  const tNav = useTranslations("nav");
  const heroParagraphs = t.raw("heroParagraphs") as readonly [string, string];
  const [p0, p1] = heroParagraphs;

  return (
    <>
      <ReadMoreBlock
        readFullHref="#in-practice"
        collapsedContent={
          <p className={bodyClass} style={{ fontFamily: "var(--font-body)" }}>
            {t("heroTeaser")}
          </p>
        }
        expandedContent={
          <>
            <p className={bodyClass} style={{ fontFamily: "var(--font-body)" }}>
              {p0}
            </p>
            <p className={bodyClass} style={{ fontFamily: "var(--font-body)" }}>
              {p1}
            </p>
            <p className={rhythmClass} style={{ fontFamily: "var(--font-body)" }}>
              {t("heroRhythm")}
            </p>
          </>
        }
      />
      <div className="mt-12 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-5">
        <Link
          href="/contact"
          className="inline-flex justify-center bg-[var(--primary)] text-[var(--on-primary)] px-7 sm:px-8 py-3.5 rounded-[var(--radius-sm)] font-medium tracking-tight hover:opacity-90 transition-opacity text-center touch-manipulation"
          style={{ fontFamily: "var(--font-body)" }}
        >
          {tNav("meetUs")}
        </Link>
        <Link
          href="/#methodology"
          scroll={false}
          className="inline-flex justify-center border border-[color-mix(in_srgb,var(--outline-variant)_22%,transparent)] text-[var(--primary)] px-7 sm:px-8 py-3.5 rounded-[var(--radius-sm)] font-medium tracking-tight hover:bg-[color-mix(in_srgb,var(--surface-container-low)_80%,transparent)] transition-colors text-center touch-manipulation"
          style={{ fontFamily: "var(--font-body)" }}
        >
          {tNav("methodology")}
        </Link>
      </div>
    </>
  );
}
